// ============================================================================
// 📑 FILTERTABS — Pestañas de Filtro Rápido
// src/features/mensagens/components/lista/FilterTabs.jsx
// ============================================================================

import React, { memo, useCallback } from 'react';
import { motion } from 'framer-motion';
import { MESSAGE_FILTERS } from '../../utils/constants';

const FilterTabs = memo(({ options, activeFilter, onChange }) => {
  const handleChange = useCallback((value) => {
    onChange?.(value);
  }, [onChange]);

  // Si no hay opciones, usar defaults
  const tabs = options?.length ? options : [
    { value: MESSAGE_FILTERS.ALL, label: 'Todas', count: 0 },
    { value: MESSAGE_FILTERS.UNREAD, label: 'Não lidas', count: 0 },
    { value: MESSAGE_FILTERS.STARRED, label: 'Favoritas', count: 0 },
    { value: MESSAGE_FILTERS.ARCHIVED, label: 'Arquivadas', count: 0 },
  ];

  return (
    <div className="flex-shrink-0 bg-card border-b border-gray-100">
      <div className="flex overflow-x-auto scrollbar-none px-2 py-2 gap-1">
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => handleChange(tab.value)}
            className={`
              relative flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium
              whitespace-nowrap transition-all duration-200
              ${activeFilter === tab.value
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
              }
            `}
          >
            {tab.label}
            {tab.count > 0 && (
              <span
                className={`
                  min-w-[18px] h-[18px] rounded-full text-xs font-bold
                  flex items-center justify-center px-1
                  ${activeFilter === tab.value
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-200 text-gray-500'
                  }
                `}
              >
                {tab.count > 99 ? '99+' : tab.count}
              </span>
            )}
            {activeFilter === tab.value && (
              <motion.div
                layoutId="filterTabIndicator"
                className="absolute bottom-0 left-3 right-3 h-0.5 bg-blue-600 rounded-full"
                transition={{ type: 'spring', stiffness: 500, damping: 30 }}
              />
            )}
          </button>
        ))}
      </div>
    </div>
  );
});

FilterTabs.displayName = 'FilterTabs';
export { FilterTabs };
export default FilterTabs;